import oneOrMore from './one-or-more';

export default {
  oneOrMore,
};
